<template>
  <div class="admin personnels">
    <AdminHeader />
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header">Personnels</div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="item in personnels">
            <div
              class="row clickable"
              :key="item.id"
              v-show="item.active == !show_deleted"
              v-bind:class="{ selected: item == personnel }"
              @click="_personnelSelected(item)"
            >
              <div class="col-12">
                {{ item.name }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <PersonnelDetail
            :personnel="personnel"
            class="col-12"
            ref="personnel_detail"
            @new="_new_personnel"
          />
        </div>
      </div>
    </div>
    <NewPersonnelModal
      ref="new_personnel_modal"
      v-show="showNewPersonnelModal"
      @close="_closeNewPersonnelModal"
    />
    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
  </div>
</template>

<script>
import AdminHeader from "@/components/admin/AdminHeader.vue";
import PersonnelDetail from "@/components/admin/personnel/PersonnelDetail.vue";
import NewPersonnelModal from "@/components/admin/personnel/NewPersonnelModal.vue";
import { mapState, mapActions } from "vuex";


export default {
  name: "Personnels",
  data: () => ({
    personnel: null,
    loading: false,
    show_deleted: false,
    showNewPersonnelModal: false,
    showCreatePasswordModal: false,
  }),
  computed: {
    ...mapState("personnels", ["personnels", "new_personnel", "create_password"]),
  },
  watch: {
    new_personnel(new_value) {
      this.personnel = new_value;
      this.$refs.new_personnel_modal.clear();
    },

  },
  methods: {
    ...mapActions("personnels", ["apiSavePersonnel", "apiCreatePersonnel", "apiCreatePassword"]),
    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },
    _save() {
      this.$refs.personnel_detail.save();
    },
    _new_personnel() {
      this.showNewPersonnelModal = true;
    },
    _closeNewPersonnelModal() {
      this.showNewPersonnelModal = false;
    },
    
    _showTab(index) {
      this.tab = index;
    },
    _personnelSelected(personnel) {
      this.personnel = personnel;
    },
    _delete_personnel() {
      if (this.personnel != null && this.personnel.id > 0) {
        this.personnel.active = !this.personnel.active;
        this.apiSavePersonnel(this.personnel);
      }
    },
  },
  components: {
    AdminHeader,
    PersonnelDetail,
    NewPersonnelModal,

  },
};
</script>
